
import { createSelector } from 'reselect'

const innerStateSelector = state => state.purchaseSend;

const isOpenSendModalSelector = createSelector(
   innerStateSelector,
   state => state.isOpenSendModal
);
const isOpenChoosePaymentModalSelector = createSelector(
   innerStateSelector,
   state => state.isOpenChoosePaymentModal
);
const isSendSelector = createSelector(
   innerStateSelector,
   state => state.isSend
);
const isFetchingSendSelector = createSelector(
   innerStateSelector,
   state => state.isFetching
);
const isNotEnoughtBalanceSelector = createSelector(
   innerStateSelector,
   state => state.isNotEnoughtBalance
);
const savedPaymentDataSelector = createSelector(
   innerStateSelector,
   state => state.savedPaymentData
);
const modalKeySelector = createSelector(
   innerStateSelector,
   state => state.modalKey
);
const modalTypeSelector = createSelector(
   innerStateSelector,
   state => state.modalType
);
const priceSelector = createSelector(
   innerStateSelector,
   state => state.price
);
const methodsSelector = createSelector(
   innerStateSelector,
   state => state.methods
);
const paymentButtonLoadingSelector = createSelector(
   innerStateSelector,
   state => state.paymentButtonLoading
);
const oneClickInfoSelector = createSelector(
   innerStateSelector,
   state => state.oneClickInfo
);
const paymentErrorSelector = createSelector(
   innerStateSelector,
   state => state.paymentError
);
const onlyWalletPaySelector = createSelector(
   innerStateSelector,
   state => state.onlyWalletPay
);
const contentDataSelector = createSelector(
   innerStateSelector,
   state => state.contentData
);
const paymentButtonResourceIdSelector = createSelector(
   innerStateSelector,
   state => state.paymentButtonResourceId

)

const purchaseDataSelector = createSelector(
   innerStateSelector,
   state => state.purchaseData
)
const isFetchingModalSelector = createSelector(
   innerStateSelector,
   state => state.isFetchingModal
)

const pageTypeSelector = createSelector(
   innerStateSelector,
   state => state.pageType
)

const mainMessageIdSelector = createSelector(
   innerStateSelector,
   state => state.mainMessageId
)


export {
   isOpenSendModalSelector,
   isOpenChoosePaymentModalSelector,
   isFetchingSendSelector,
   isSendSelector,
   isNotEnoughtBalanceSelector,
   savedPaymentDataSelector,
   modalKeySelector,
   modalTypeSelector,
   priceSelector,
   methodsSelector,
   paymentButtonLoadingSelector,
   oneClickInfoSelector,
   paymentErrorSelector,
   onlyWalletPaySelector,
   contentDataSelector,
   paymentButtonResourceIdSelector,
   purchaseDataSelector,
   isFetchingModalSelector,
   pageTypeSelector,
   mainMessageIdSelector,
}
